/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceDomainPersonaCreateRequest
 */
export interface WorkspaceDomainPersonaCreateRequest {
    /**
     * Display name for the workspace domain persona
     * @type {string}
     * @memberof WorkspaceDomainPersonaCreateRequest
     */
    name: string;
    /**
     * URL of the workspace domain persona avatar
     * @type {string}
     * @memberof WorkspaceDomainPersonaCreateRequest
     */
    avatarUrl: string;
}

/**
 * Check if a given object implements the WorkspaceDomainPersonaCreateRequest interface.
 */
export function instanceOfWorkspaceDomainPersonaCreateRequest(value: object): value is WorkspaceDomainPersonaCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function WorkspaceDomainPersonaCreateRequestFromJSON(json: any): WorkspaceDomainPersonaCreateRequest {
    return WorkspaceDomainPersonaCreateRequestFromJSONTyped(json, false);
}

export function WorkspaceDomainPersonaCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceDomainPersonaCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
    };
}

export function WorkspaceDomainPersonaCreateRequestToJSON(json: any): WorkspaceDomainPersonaCreateRequest {
    return WorkspaceDomainPersonaCreateRequestToJSONTyped(json, false);
}

export function WorkspaceDomainPersonaCreateRequestToJSONTyped(value?: WorkspaceDomainPersonaCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
    };
}

